import { CheckboxText, ICheckboxState } from 'common-front/src/designSystem/components/checkbox';
import { DropdownFilters } from 'common-front/src/designSystem/components/dropdownFilters';
import { Select } from 'common-front/src/designSystem/components/select/select';
import { Separator } from 'common-front/src/designSystem/components/separator';
import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { MassAssignSlotsQuery, SegmentId } from 'common/src/generated/types';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';

interface IMassAssignFiltersProps {
    excludeFull: boolean;
    excludePast: boolean;
    name: string;
    filterAvailabilities: boolean;
    filterWished: boolean;
    segmentId: SegmentId;
    segments: MassAssignSlotsQuery['event']['segments'];

    setExcludeFull(excludeFull: boolean): void;
    setExcludePast(excludePast: boolean): void;
    setFilterAvailabilities(filterAvailabilities: boolean): void;
    setFilterWished(filterWished: boolean): void;
    setName(name: string): void;
    setSegmentId(segmentId: SegmentId): void;
}

export const MassAssignFilters = (props: IMassAssignFiltersProps) => {
    const translate = useTranslate();
    const [areFiltersOpen, setAreFiltersOpen] = React.useState(false);
    const [segmentId, setSegmentId] = React.useState(props.segmentId);
    const [hiddenState, setHiddenState] = React.useState<ICheckboxState>(
        props.excludeFull ? 'checked' : 'unchecked'
    );
    const [pastState, setPastState] = React.useState<ICheckboxState>(
        props.excludePast ? 'checked' : 'unchecked'
    );
    const [filterAvailabilitiesState, setFilterAvailabilitiesState] =
        React.useState<ICheckboxState>(props.filterAvailabilities ? 'checked' : 'unchecked');
    const [filterWishedState, setFilterWishedState] = React.useState<ICheckboxState>(
        props.filterWished ? 'checked' : 'unchecked'
    );
    const apply = () => {
        props.setExcludeFull(hiddenState === 'checked');
        props.setExcludePast(pastState === 'checked');
        props.setFilterAvailabilities(filterAvailabilitiesState === 'checked');
        props.setFilterWished(filterWishedState === 'checked');
        props.setSegmentId(segmentId);

        setAreFiltersOpen(false);
    };
    const reinit = () => {
        props.setExcludeFull(false);
        setHiddenState('unchecked');
        props.setExcludePast(false);
        setPastState('unchecked');
        props.setFilterAvailabilities(false);
        setFilterAvailabilitiesState('unchecked');
        props.setFilterWished(false);
        setFilterWishedState('unchecked');
        props.setSegmentId(-1 as SegmentId);
        setSegmentId(-1 as SegmentId);
        props.setName('');

        setAreFiltersOpen(false);
    };
    const numberOfAppliedFilters =
        (props.excludeFull ? 1 : 0) +
        (props.excludePast ? 1 : 0) +
        (props.filterAvailabilities ? 1 : 0) +
        (props.filterWished ? 1 : 0) +
        (props.segmentId === -1 ? 0 : 1);

    return (
        <Flex
            css={{
                background: '$gray100',
                borderRadius: '$2',
                padding: '$4'
            }}
            gap="3"
        >
            <Box css={{ flex: '1' }}>
                <TextInput
                    icon="magnifying-glass"
                    placeholder={translate('rechercher_une_69998')}
                    value={props.name}
                    onChange={(newName: string) => {
                        props.setName(newName);
                    }}
                />
            </Box>

            <DropdownFilters
                apply={apply}
                color="white"
                isOpen={areFiltersOpen}
                numberOfAppliedFilters={numberOfAppliedFilters}
                reinit={reinit}
                showButtons={true}
                onStateChange={setAreFiltersOpen}
            >
                <Select
                    label="Vues personnalisées"
                    shouldParseAsInt={true}
                    value={segmentId}
                    onChange={(newSegmentId) => {
                        setSegmentId(newSegmentId as SegmentId);
                    }}
                >
                    <option value={-1}>{translate('vue_personnalis_97654')}</option>

                    {props.segments.map((segment) => (
                        <option key={segment.id} value={segment.id}>
                            {segment.name}
                        </option>
                    ))}
                </Select>

                <CheckboxText state={hiddenState} onClick={setHiddenState}>
                    {translate('masquer_les_cr_14425')}
                </CheckboxText>

                <CheckboxText state={pastState} onClick={setPastState}>
                    {translate('masquer_les_cr_05336')}
                </CheckboxText>

                <Separator direction="horizontal" />

                <Box font="gray900 textSm medium">{translate('filtres_sur_les_73833')}</Box>

                <CheckboxText
                    state={filterAvailabilitiesState}
                    onClick={setFilterAvailabilitiesState}
                >
                    {translate('filtrer_selon_l_74774')}
                </CheckboxText>

                <CheckboxText state={filterWishedState} onClick={setFilterWishedState}>
                    {translate('filtrer_selon_l_76350')}
                </CheckboxText>
            </DropdownFilters>
        </Flex>
    );
};
